import React from "react";
import TextField from "./TextField";
import NumberField from "./NumberField";
import DateField from "./DateField";
import TextArea from "./TextArea";
import SelectField from "./SelectField";
import ChoiceField from "./ChoiceField";
import AddressField from "./AddressField";
import OtpField from "./OtpField";

const BY_TYPE = {
	text: TextField,
	email: TextField,
	tel: TextField,
	number: NumberField,
	date: DateField,
	textarea: TextArea,
	select: SelectField,
	choice: ChoiceField,
	address: AddressField,
	otp: OtpField,
};

/** The component for a field `type` (a multiple `select` is checkboxes); null for an unknown type. */
export function fieldComponent(field) {
	if (field?.type === "select" && field.multiple) return ChoiceField;
	return BY_TYPE[field?.type] || null;
}

/** One `data_collection` field. An unknown type renders nothing here — the renderer falls back first. */
export default function FieldControl(props) {
	const Component = fieldComponent(props.field);
	return Component ? <Component {...props} /> : null;
}
